/** Normalize API/DB values (0, "0", false) to boolean. Default open when missing. */
export function parseCompetitionRegistrationEnabled(value, defaultOpen = true) {
  if (value === undefined || value === null || value === "") {
    return defaultOpen;
  }
  if (value === false || value === 0 || value === "0" || value === "false") {
    return false;
  }
  if (value === true || value === 1 || value === "1" || value === "true") {
    return true;
  }
  return defaultOpen;
}

/** User registration + contestant uploads (when false, API blocks non-admin). */
export function isCompetitionRegistrationOpen(competition) {
  if (!competition) return false;
  return parseCompetitionRegistrationEnabled(competition.registration_enabled, true);
}
